import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import TauriBreadCrumbDropdown from '../TauriBreadcrumbDropdown';

const TauriMonthAndYearDropdown = ({ onDateChange }) => {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonthIndex = currentDate.getMonth();
    const numberOfYears = 1;

    const years = [];
    for (let i = currentYear - numberOfYears; i <= currentYear; i++) {
        years.push(i);
    }

    const getInitialValue = (key, defaultValue) => parseInt(localStorage.getItem(key), 10) || defaultValue;

    const [selectedDates, setSelectedDates] = useState({
        FromMonth: getInitialValue('FromMonth', currentMonthIndex + 1),
        FromYear: getInitialValue('FromYear', currentYear),
        ToMonth: getInitialValue('ToMonth', currentMonthIndex + 1),
        ToYear: getInitialValue('ToYear', currentYear),
    });

    useEffect(() => {
        localStorage.setItem('FromMonth', selectedDates.FromMonth);
        localStorage.setItem('FromYear', selectedDates.FromYear);
        localStorage.setItem('ToMonth', selectedDates.ToMonth);
        localStorage.setItem('ToYear', selectedDates.ToYear);
        onDateChange({
            FromMonth: selectedDates.FromMonth,
            FromYear: selectedDates.FromYear,
            ToMonth: selectedDates.ToMonth,
            ToYear: selectedDates.ToYear
        });
    }, [selectedDates])

    useEffect(() => {
        onDateChange(selectedDates);
    }, []);

    const monthItems = months.map((month, index) => ({
        label: month,
        value: index + 1,
    }));

    const yearItems = years.map((year) => ({
        label: year.toString(),
        value: year,
    }));

    return (
        <>
            <div className="label-date mx-1">From</div>
            <TauriBreadCrumbDropdown
                items={monthItems}
                onSelect={(month) => setSelectedDates((prev) => ({ ...prev, FromMonth: month }))}
                selectedItem={months[selectedDates.FromMonth - 1]}
                variant="secondary"
                id="monthDropdown"
                className="mr-3"
                placeholder="--Select Month--"
            />

            <TauriBreadCrumbDropdown
                items={yearItems}
                onSelect={(year) => setSelectedDates((prev) => ({ ...prev, FromYear: year }))}
                selectedItem={selectedDates.FromYear}
                variant="secondary"
                id="yearDropdown"
                className="mr-3"
                placeholder="--Select Year--"
            />

            <div className="label-date mx-1">To</div>

            <TauriBreadCrumbDropdown
                items={monthItems}
                onSelect={(month) => setSelectedDates((prev) => ({ ...prev, ToMonth: month }))}
                selectedItem={months[selectedDates.ToMonth - 1]}
                variant="secondary"
                id="toMonthDropdown"
                className="mr-3"
                placeholder="--Select Month--"
            />

            <TauriBreadCrumbDropdown
                items={yearItems}
                onSelect={(year) => setSelectedDates((prev) => ({ ...prev, ToYear: year }))}
                selectedItem={selectedDates.ToYear}
                variant="secondary"
                id="toYearDropdown"
                className="mr-3"
                placeholder="--Select Year--"
            />
        </>
    )
}
export default TauriMonthAndYearDropdown